import gql from 'graphql-tag';

export const CHECK_TOKEN = gql`
  mutation checkToken(
    $id: Int!
    $token: String!
    $isConfirmPassword: Boolean
    $isResetPassword: Boolean
  ) {
    checkToken(
      id: $id
      token: $token
      isResetPassword: $isResetPassword
      isConfirmPassword: $isConfirmPassword
    ) {
      id
    }
  }
`;
